/**
 * Skeleton loader component for onboarding step cards
 * Matches the appearance of OnboardingStepCard during loading states
 */

import React from "react";
import { Box, Paper, Skeleton, Stack } from "@mantine/core";

/**
 * Skeleton loader that matches the onboarding step card appearance
 */
const OnboardingStepSkeleton: React.FC = () => {
  return (
    <Paper
      shadow="sm"
      p="sm"
      radius="md"
      style={{
        position: "relative",
        overflow: "hidden",
        border: "2px solid #e9ecef",
        maxWidth: "240px",
        width: "100%",
        aspectRatio: "1",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Status Badge Skeleton */}
      <Box
        style={{
          position: "absolute",
          top: 12,
          right: 12,
          zIndex: 1,
        }}
      >
        <Skeleton height={22} width={90} radius="xl" />
      </Box>

      <Stack gap="sm" style={{ flex: 1 }}>
        {/* Icon Skeleton */}
        <Skeleton height={48} width={48} radius="10px" />

        {/* Title Skeleton */}
        <Skeleton height={24} width="90%" />
        <Skeleton height={24} width="70%" />

        {/* Description Skeleton */}
        <Stack gap={6} style={{ marginTop: "auto" }}>
          <Skeleton height={12} width="100%" />
          <Skeleton height={12} width="95%" />
          <Skeleton height={12} width="80%" />
        </Stack>
      </Stack>
    </Paper>
  );
};

export default OnboardingStepSkeleton;
